import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import { DocumentDirection } from '~/types/document';
import lazyImport from '~/utils/lazyImport';

const AnalyticsSalesPricesDashboardPage = lazyImport(
  () => import('~/views/analytics/sales-prices-dashboard/AnalyticsSalesPricesDashboardPage'),
);
const ItemVolumesDashboardPage = lazyImport(
  () => import('~/views/analytics/item-volumes-dashboard/ItemVolumesDashboardPage'),
);
const ItemQuantitiesDashboardPage = lazyImport(
  () => import('~/views/analytics/item-quantities-dashboard/ItemQuantitiesDashboardPage'),
);
const AveragePricesDashboardPage = lazyImport(
  () => import('~/views/analytics/average-prices-dashboard/AveragePricesDashboardPage'),
);

export const analyticsSalesPricesDashboardPages: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={RouteConfig.AnalyticsSalesProductsPriceChanges.buildLink()} replace />,
  },
  {
    path: 'products-price-changes',
    element: <AnalyticsSalesPricesDashboardPage />,
  },
  {
    path: 'item-volumes',
    element: <ItemVolumesDashboardPage direction={DocumentDirection.issued} section="item_volumes" />,
  },
  {
    path: 'item-quantities',
    element: <ItemQuantitiesDashboardPage direction={DocumentDirection.issued} section="item_quantities" />,
  },
  {
    path: 'average-prices',
    element: <AveragePricesDashboardPage direction={DocumentDirection.issued} section="average_prices" />,
  },
];
